import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import { Button, Typography } from '@material-ui/core';
import FormTextField from '../../form/FormTextField';
import { registrationFormValidation } from '../../../models/auth/AuthModelValidation';
import FormCheckBoxWithLabel from '../../legacyForm/FormCheckBoxWithLabel';

const RegistrationForm = ({ t, onSubmit, consent1Required, consent2Required }) => {
  return (
    <Form
      onSubmit={onSubmit}
      validate={values => registrationFormValidation(values, consent1Required, consent2Required)}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit}>
          <Typography variant="h5" gutterBottom>Nowe konto użytkownika</Typography>
          <Typography gutterBottom variant="overline" component="div">Dane podstawowe</Typography>
          <div>
            <Field
              name="email"
              type="email"
              component={FormTextField}
              label="Email"
              placeholder="Twój email posłuży do logowania w systemie"
              fullWidth
              autoFocus
            />
          </div>
          <div>
            <Field
              name="firstName"
              component={FormTextField}
              label="Imię"
              fullWidth
            />
          </div>
          <div>
            <Field
              name="lastName"
              component={FormTextField}
              label="Nazwisko"
              fullWidth
            />
          </div>
          <div>
            <Field
              name="password"
              type="password"
              component={FormTextField}
              label="Hasło"
              placeholder="Hasło musi zawierać co najmniej 8 znaków, w tym jedną cyfrę, wielką literę oraz znak specjalny"
              fullWidth
            />
          </div>

          <div>
            <Field
              name="consent1"
              component={FormCheckBoxWithLabel}
              label={<div>Akceptuję <a href="/regulamin" target="_blank" rel="noopener noreferrer">Regulamin</a>, żeby utworzyć i korzystać z konta budżetu obywatelskiego</div>}
              fullWidth
            />
            <Field
              name="consent2"
              component={FormCheckBoxWithLabel}
              label={<div>Wyrażam zgodę na przetwarzanie moich danych w budżecie obywatelskim. Zostałem poinformowany, że podanie danych jest dobrowolne a także, że w każdym czasie mogę odwołać udzieloną zgodę. <a href="/polityka-prywatnosci" target="_blank" rel="noopener noreferrer">Pełna treść klauzuli informacyjnej</a></div>}
              fullWidth
            />

          </div>

          <Button variant="contained" color="primary" type="submit" disabled={submitting} style={{ marginTop: 20 }}>
            {submitting ? t('auth.registration.registrationInProgressButton') : t('auth.registration.registrationButton')}
          </Button>
        </form>
      )}
    />
  );
};

RegistrationForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  consent1Required: PropTypes.bool,
  consent2Required: PropTypes.bool,
};

export default translate()(RegistrationForm);



// WEBPACK FOOTER //
// ./src/components/budgetAuth/registration/RegistrationForm.js